import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const PromoAuthContext = createContext(null);

export const PromoAuthProvider = ({ children }) => {
  const [account, setAccount] = useState(null); // null=loading, false=guest, obj=logged-in
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const boot = async () => {
      const token = localStorage.getItem("ss_promo_token");
      if (!token) {
        setAccount(false);
        setInitializing(false);
        return;
      }
      try {
        const { data } = await api.get("/aff-panel/auth/me");
        setAccount(data.account);
      } catch {
        setAccount(false);
      } finally {
        setInitializing(false);
      }
    };
    boot();
  }, []);

  const login = async (username, password, totp_code) => {
    const { data } = await api.post("/aff-panel/auth/login", { username, password, totp_code });
    if (data?.requires_2fa) {
      return { requires_2fa: true, challenge_token: data.challenge_token };
    }
    if (data?.token) localStorage.setItem("ss_promo_token", data.token);
    setAccount(data.account);
    return data;
  };

  const verify2FA = async ({ challenge_token, totp_code, backup_code }) => {
    const { data } = await api.post("/aff-panel/auth/2fa-verify", { challenge_token, totp_code, backup_code });
    if (data?.token) localStorage.setItem("ss_promo_token", data.token);
    setAccount(data.account);
    return data;
  };

  const logout = async () => {
    try { await api.post("/aff-panel/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("ss_promo_token");
    setAccount(false);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/aff-panel/auth/me");
      setAccount(data.account);
      return data.account;
    } catch { return null; }
  };

  return (
    <PromoAuthContext.Provider value={{ account, login, verify2FA, logout, refresh, initializing }}>
      {children}
    </PromoAuthContext.Provider>
  );
};

export const usePromoAuth = () => useContext(PromoAuthContext);
